import React, { useState } from "react";
import { SidebarMenuItem } from "../../components/sidebar";
import { ButtonSidebar } from "../../components";
import { FiChevronsLeft, FiChevronsRight } from "react-icons/fi";

const Sidebar = (props) => {
  const [isCollapse, setIsCollapse] = useState(false);
  const { app = "tenken", sidebar } = props;
  const sidebarItems = sidebar.items ? sidebar.items : [];
  const sidebarBaseClass = "h-dvh bg-white border-r border-[#e0e0e0] px-[8px] py-[12px] relative";
  const sidebarWidthClass = isCollapse
    ? "w-[66px] min-w-[66px]"
    : "w-[150px] min-w-[150px]";
  const sidebarClassName = `${sidebarBaseClass} ${sidebarWidthClass}`;
  return (
    <>
      <div className="relative">
        <div className={isCollapse ? "hidden" : "absolute left-[150px] top-0 z-10"}>
          <ButtonSidebar onClick={() => setIsCollapse(true)}>
            <FiChevronsLeft size={24} />
          </ButtonSidebar>
        </div>
        <div className={isCollapse ? "left-0 top-0 z-10 absolute" : "hidden"}>
          <ButtonSidebar onClick={() => setIsCollapse(false)}>
            <FiChevronsRight size={24} />
          </ButtonSidebar>
        </div>
      </div>
      <div className={`${sidebarClassName} ${isCollapse ? "hidden" : ""}`}>
        <div className="flex flex-col items-center space-y-[12px]">
          {sidebar.title && <h5>{sidebar.title}</h5>}
          <div className="w-full px-[8px] space-y-[12px]">
            {sidebarItems.map((item, index) => {
              if (item.hasOwnProperty("access") && item.access === false) {
                return null;
              }
              return <SidebarMenuItem key={index} app={app} item={item} />;
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
